import React, { useContext, useEffect, useState } from "react";
import {
  DialogActions,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { BarraDeFerramentas } from "../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { get } from "../../Services/tokenConfig";
import { AuthContext } from "../../AuthContext/AuthContext";
import { func_print } from "../../Func_genericas/func_print";

interface IHistorico {
  id_caderno: number;
  cultura_caderno: string;
  ano: number;
  link: string;
  publico: boolean;
  id_rosto: number;
  create_date: string;
  last_update: string;
  uuid: string;
}

interface IDialogReplicarCadernoDeAnoAnterior {
  set_id_caderno_a_replicar: (obj: string) => void;
  set_id_rosto_a_replicar: (obj: string) => void;
  set_ano_novo_caderno: (obj: Dayjs | null) => void;
  handle_replicar_caderno_de_ano_anterior: () => void;
  id_agri: number | undefined;
  setIsLoading: (flag: boolean) => void;
}

export const DialogReplicarCadernoDeAnoAnterior = ({
  set_id_caderno_a_replicar,
  set_id_rosto_a_replicar,
  set_ano_novo_caderno,
  handle_replicar_caderno_de_ano_anterior,
  id_agri,
  setIsLoading,
}: IDialogReplicarCadernoDeAnoAnterior) => {

  const auth = useContext(AuthContext);


  const [valueYear, setValueYear] = useState<Dayjs | null>(dayjs);
  const [caderno_selecionado, set_caderno_selecionado] = useState<IHistorico>();
  const [listHistorico, setListHistorico] = useState<IHistorico[]>([]);

  const getHistoric = async () => {
    try {
      setIsLoading(true);

      let res = await get(auth.token.cookie_token, `/get_historico_idAgri/${id_agri}`);
      if (res.status === 200) {
        setListHistorico(res.data.result);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      func_print("getHistoric", error, true);
    }
  };
  useEffect(() => {
    (async () => {
      await getHistoric();
    })();
  }, []);

  const handle_change_ano = (id_caderno: number | string) => {
    let aux_caderno_selecionado = listHistorico.find((el) => {
      if (el.id_caderno === id_caderno) {
        return el
      }
    })
    if (aux_caderno_selecionado !== undefined) {
      set_id_caderno_a_replicar(aux_caderno_selecionado.id_caderno.toString())
      set_id_rosto_a_replicar(aux_caderno_selecionado.id_rosto.toString())
      set_caderno_selecionado(aux_caderno_selecionado)
    }
  }
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // backgroundColor:'red',
          // height:'100%'
        }}
      >
        <DialogActions>
          <Stack direction="column">
            <div style={{
              marginTop: 20,
              marginBottom: 20
            }}>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year"]}
                  label={
                    <Typography fontFamily="candara" fontSize={18}>
                      Selecionar ano do novo caderno
                    </Typography>
                  }
                  value={valueYear}
                  onChange={(valueYear) => {
                    setValueYear(valueYear);
                    set_ano_novo_caderno(valueYear)
                  }}
                  maxDate={dayjs()}
                  minDate={dayjs("2010")}
                // renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>

            </div>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Caderno a copiar</InputLabel>
              <Select
                value={caderno_selecionado === undefined ? '' : caderno_selecionado.id_caderno}
                label={'Caderno a copiar'}
                sx={{
                  fontSize: 14,
                  fontFamily: "verdana",
                  minWidth: 200,
                  color: 'black'
                }}
                onChange={(e) => handle_change_ano(e.target.value)}
              >

                {listHistorico.map((item: IHistorico, key) => {

                  return (
                    <MenuItem key={key} value={item.id_caderno}>
                      <Typography
                        style={{
                          fontSize: 14,
                          fontFamily: "candara",
                        }}
                      >
                        {item.cultura_caderno === null ? item.ano : item.ano + ' ' + item.cultura_caderno}
                      </Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Stack>

        </DialogActions>
      </div>
      <Stack width={'100%'} direction="row" display="flex" justifyContent="end" paddingTop={5} paddingRight={5}>
        <BarraDeFerramentas
          mostrarBotaoNovo
          aoClicarNovo={() => handle_replicar_caderno_de_ano_anterior()}
          textoBotaoNovo="CRIAR"
        />
      </Stack>
    </>
  );
};
